import builder from '@ahmdigital/urls/lib/builder';

import { ProductType } from '../../types/product';
import constants from '../../ahm-constants';

const UrlService = {
  getProductUrl: (productId?: ProductType['id']) =>
    builder.getProductUrl({
      errorUrl: constants.URLS.SALES.ERROR_404,
      productId,
      rawUrl: constants.URLS.SALES.PRODUCT,
    }),
};

export default UrlService;
